import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./components/pages/Home";
import Dashboard from "./components/pages/Dashboard";
import Produto from "./components/pages/Produto";
import Categoria from "./components/pages/Categoria";
import Mesa from "./components/pages/Mesa";
import Usuario from "./components/pages/Usuario";
import Pedido from "./components/pages/Pedido";
import Pos from "./components/pages/Pos";
import Estoque from "./components/pages/Estoque";
import Factura from "./components/pages/Factura";
import FacturaTicket from "./components/pages/FacturaTicket";
import Conta from "./components/pages/Conta";
import Empresa from "./components/pages/Empresa";
import ProdutosVendidos from "./components/pages/ProdutosVendidos";
import RltProdutosVendidos from "./components/pages/RltProdutosVendidos";
import Baixa from "./components/pages/Baixa";
import Inventario from "./components/pages/Inventario";
import Documentos from "./components/pages/Documentos";
import PedidoCancelado from "./components/pages/PedidoCancelado";
import PedidoCozinha from "./components/pages/PedidoCozinha";

// IMPORTANTE: Use o componente WITH_PREVIEW para ter visualização antes do download
import QRCodeGenerator from "./components/QRCodeGenerator";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Rota de login fora da estrutura protegida */}
        <Route path="/" element={<Login />} />
        
        {/* Rotas públicas (sem autenticação) */}
        <Route path="/vendas/:id/:token" element={<Pos />} />
        <Route path="/factura/:id" element={<Factura />} />
        <Route path="/factura_ticket/:id" element={<FacturaTicket />} />
        <Route path="/cozinha" element={<PedidoCozinha />} />
        <Route path="/pdf_relatorio/:dataInicio/:dataFim" element={<RltProdutosVendidos />} />
        
        {/* 
          ROTA DO GERADOR DE QR CODE COM MOLDURA 
          Uso: /qr-download?content=URL_DO_MENU&filename=nome_do_arquivo
          Exemplo: /qr-download?content=https://socialite.milvendas.ao/vendas/1/abc&filename=Mesa_01
        */}
        <Route path="/qr-download" element={<QRCodeGenerator />} />

        {/* Rotas protegidas dentro de Home */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="produtos" element={<Produto />} />
          <Route path="mesas" element={<Mesa />} />
          <Route path="categorias" element={<Categoria />} />
          <Route path="usuarios" element={<Usuario />} />
          <Route path="pedidos" element={<Pedido />} />
          <Route path="estoque" element={<Estoque />} />
          <Route path="baixa" element={<Baixa />} />
          <Route path="inventario" element={<Inventario />} />
          <Route path="contas" element={<Conta />} />
          <Route path="empresa" element={<Empresa />} />
          <Route path="relatorio_produtos_vendidos" element={<ProdutosVendidos />} />
          <Route path="documentos" element={<Documentos />} />
          <Route path="pedidos_cancelados" element={<PedidoCancelado />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;